module.exports = __webpack_public_path__ + "img/goodsrwdclose.41735e15.png";